import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SAVE_SERVICE } from '@core/saves/saves.interface';
import { ACTIVATION_SERVICE } from './activation.service.interface';

// Checks if the user is activated
export const activatedGuard: CanActivateFn = () => {
  const activationService = inject(ACTIVATION_SERVICE);

  if (activationService.isActivatedSchoolDevice() || activationService.isActivatedHomeDevice()) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree(['/selectDeviceType']);
};

export const activatedSchoolDeviceGuard: CanActivateFn = () => {
  const activationService = inject(ACTIVATION_SERVICE);
  if (activationService.isActivatedSchoolDevice()) {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree(['/selectDeviceType']);
};

export const activatedHomeDeivceGuard: CanActivateFn = () => {
  const activationService = inject(ACTIVATION_SERVICE);
  if (activationService.isActivatedHomeDevice()) {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree(['/selectDeviceType']);
};

// Checks if the user is logged in
export const loggedInGuard: CanActivateFn = () => {
  const saveService = inject(SAVE_SERVICE);

  if (saveService.isLoggedIn()) {
    return true;
  }

  const router = inject(Router);

  const activationService = inject(ACTIVATION_SERVICE);
  if (activationService.isActivatedSchoolDevice()) {
    return router.createUrlTree(['/select-profile']);
  }
  if (activationService.isActivatedHomeDevice()) {
    return router.createUrlTree(['/select-home-profile']);
  }

  return router.createUrlTree(['/selectDeviceType']);
};

// Checks if the user is not logged in
export const notLoggedInGuard: CanActivateFn = () => {
  const saveService = inject(SAVE_SERVICE);

  if (!saveService.isLoggedIn()) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree(['/']);
};

// Checks if the user is NOT activated
export const notActivatedGuard: CanActivateFn = () => {
  const activationService = inject(ACTIVATION_SERVICE);

  if (!activationService.isActivatedSchoolDevice() && !activationService.isActivatedHomeDevice()) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree(['/']);
};
